import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import $ from 'jquery'
import PricingBracketsForm from './barckets.component.jsx'

class CustomBracketModal extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            brackets: this.props.value || [],
            billingMethods: this.props.billingMethods || [],
            pricingStrategy: this.props.pricingStrategy || '',
            unitOfMeasure: this.props.unitOfMeasure || '',
            currency: this.props.currency || '',
        }

        this.closeModal = this.closeModal.bind(this)
        this.handleBracketsChange = this.handleBracketsChange.bind(this)
        this.save = this.save.bind(this)
        this.onChange = this.props.onChange || function () { }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethods: nextProps.billingMethods || [],
            pricingStrategy: nextProps.pricingStrategy || '',
        })
    }

    componentDidMount() {
        $('#attachCustomerModal').modal('show')
    }

    closeModal(event) {
        event?.preventDefault()
        $('#attachCustomerModal').modal('hide')
        const onClose = this.props.onClose(this.state.brackets) || function () { }
        onClose()
    }

    save(event) {
        this.onChange(this.state.brackets)
        this.closeModal(event)
    }


    handleBracketsChange(value) {
        this.setState({
            brackets: value,
        }, this.valueChanged)
    }

    valueChanged() {
        this.onChange(this.state.brackets)
    }

    render() {
        return (
            <div className="modal"
                id="attachCustomerModal"
                role="dialog"
                aria-labelledby="addQuoteItemModalLabel"
                data-keyboard="false"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title border-0 m-0 p-0" id="addQuoteItemModalLabel">
                                <FormattedMessage
                                    id="bracket.modal.add_form.title"
                                    defaultMessage="Edit pricing brackets"
                                />
                            </h5>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <PricingBracketsForm
                                    onChange={this.handleBracketsChange}
                                    value={this.state.brackets}
                                    unitOfMeasure={this.state.unitOfMeasure}
                                    billingMethods={this.state.billingMethods}
                                    pricingStrategy={this.state.pricingStrategy}
                                    currency={this.state.currency}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="bracket.modal.add_form.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                            <button type="button" className="btn btn-primary" onClick={this.save}>
                                <FormattedMessage
                                    id="bracket.modal.add_form.save_btn"
                                    defaultMessage="Save brackets"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CustomBracketModal





// WEBPACK FOOTER //
// ./src/product/form/custom-bracket/modal.component.jsx